// @flow

export class PointModel {
    id: number = 0;
    name = '';
    type = '';
    information: {
        name: string,
        isRestrict: boolean
    } = {
        name: '',
        isRestrict: true
    };
    address: {
        address: string,
        district: string,
        city: string,
        state: string,
        zip: string,
        complement: string
    } = {
        address: '',
        district: '',
        city: '',
        state: '',
        zip: '',
        complement: ''
    };
    location: {
        latitude: 0,
        longitude: 0
    };

    constructor (feature: any, type: string) {
        if (type) {
            this.type = type;
        }

        if (feature && feature.properties && feature.geometry) {
            this.id = Number(feature.properties.Id);
            this.information = {
                name: feature.properties['Name'],
                description: feature.properties['Description'],
                isRestrict: feature.properties['IsRestrict']
            };

            this.address = {
                address: feature.properties['Logradouro'],
                district: feature.properties['Neighborhood'],
                city: feature.properties['County'],
                state: feature.properties['FederativeUnit'],
                zip: feature.properties['Cep'],
                complement: feature.properties['Description']
            };

            this.location = {
                latitude: feature.geometry.coordinates[1],
                longitude: feature.geometry.coordinates[0]
            };
        }
    }
}



// WEBPACK FOOTER //
// ./src/models/point.model.js